module.exports = __webpack_public_path__ + "ce291ec9b658d7ff597a22e2ee8a686d.png";